import { useMutation } from 'react-query';
import * as RestApi from 'core/network/RestApi';
import { AgentQueryRequest, AgentQueryResponse } from '../types';

/**
 * Hook for querying the campaign agent
 * Uses React Query mutation pattern consistent with the codebase
 * Supports both API Gateway (production) and direct HTTP (local dev) modes
 */
export function useAgent() {
  const mutation = useMutation(async (request: AgentQueryRequest) => {
    return RestApi.post<AgentQueryResponse, AgentQueryRequest>(
      `/sites/${request.siteId}/agents/campaigns/${request.feature}`,
      request,
    );
  });

  return {
    queryAgent: (
      request: AgentQueryRequest,
      options?: {
        onSuccess?: (data: RestApi.RestApiResponse<AgentQueryResponse>) => void;
        onError?: (error: any) => void;
      },
    ) => {
      mutation.mutate(request, options);
    },
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
  };
}
